import useReveal from "@/hooks/useReveal";

const PARAGRAPHS = [
  "With an MBA in Marketing and over 13 years of professional experience, Mohd Azam Khan brings strategic marketing expertise and a growth-oriented approach to helping businesses strengthen their digital presence and achieve their marketing objectives.",
  "As the founder of Gold Mind Business, he focuses on performance-driven digital marketing solutions that help businesses build brand authority, reach relevant audiences, generate quality leads, and create sustainable growth opportunities.",
  "His approach combines marketing strategy, audience targeting, creative advertising, and data-driven campaign optimisation to help brands move beyond online visibility and focus on meaningful business outcomes.",
  "Gold Mind Business provides digital growth solutions, including Meta Ads (Facebook and Instagram), Google Ads, AI-powered advertisement videos, social media marketing, and lead generation.",
  "With a strong belief that effective marketing requires both creativity and strategy, Mohd Azam Khan aims to help organisations build stronger brands, connect with the right audiences, and turn marketing efforts into measurable opportunities for growth.",
];

export default function AboutFounder() {
  const ref = useReveal();
  return (
    <section
      id="about"
      ref={ref}
      data-testid="about-founder-section"
      className="py-16 sm:py-24 bg-[#F8F9FA]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-5 fade-up">
          <div className="relative max-w-md mx-auto">
            <div className="absolute inset-x-6 bottom-0 top-16 bg-[#B01116] rounded-2xl" aria-hidden="true" />
            <img
              src="/images/founder.webp"
              alt="Mohd Azam Khan — Founder, Gold Mind Business"
              loading="lazy"
              decoding="async"
              data-testid="founder-photo"
              className="relative w-full h-auto drop-shadow-xl"
            />
            <div className="relative bg-[#FFC107] rounded-b-2xl mx-6 px-6 py-4 text-center -mt-1">
              <div className="font-display font-black text-[#111827] text-lg leading-tight">
                Mohd Azam Khan
              </div>
              <div className="font-accent font-bold text-[#B01116] text-xs uppercase tracking-[0.15em] mt-1">
                Founder | Gold Mind Business
              </div>
            </div>
          </div>
        </div>

        <div className="lg:col-span-7 fade-up" style={{ transitionDelay: "100ms" }}>
          <span className="gmb-badge-yellow">About the Founder</span>
          <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[#B01116]">
            Mohd Azam Khan
          </h2>
          <div className="mt-2 font-accent font-bold text-gray-900 text-base">
            Founder | Gold Mind Business
          </div>

          <div className="mt-6 space-y-4">
            {PARAGRAPHS.map((p, i) => (
              <p key={i} className="text-gray-600 text-base leading-relaxed">
                {p}
              </p>
            ))}
          </div>

          <p className="mt-8 font-display font-bold text-xl text-[#B01116]">
            Gold Mind Business — Your Growth, Our Vision.
          </p>
        </div>
      </div>
    </section>
  );
}
